/**
 * DAB-33 Limited products
 **/
'use strict';

var isBigVolume = JSON.parse($('#isBigVolume').val()) || false;
var basketHasBigVolumeInside =
    JSON.parse($('#basketHasBigVolumeInside').val()) || false;
var basketHasNormalVolumeInside =
    JSON.parse($('#basketHasNormalVolumeInside').val()) || false;

function OnInitBigVolumeproductProductValidation() {

    if (
        (isBigVolume && basketHasBigVolumeInside) ||
        (isBigVolume && basketHasNormalVolumeInside) ||
        (!isBigVolume && basketHasBigVolumeInside)
    ) {
        $('.variationAttribute,#btn-add-to-cart').css({ display: 'none' });
        $('#btn-cart-modal-bigVolume').removeClass('d-none');
        $('.msg-container').removeClass('d-none');
        $('#btn-cart-modal-bigVolume').attr('disabled', false);


        $('#btn-cart-modal-bigVolume').on('click', function () {
            $('#bigVolumeModal').modal('show');
            $('#btn-cart-modal-bigVolume').attr('disabled', true);
        });

        $('.close-message').on('click', function () {
            $('#bigVolumeModal').modal('hide');
        });
    }
}

module.exports = {
    OnInitBigVolumeproductProductValidation:
        OnInitBigVolumeproductProductValidation
};
